/* Gauge theme – small, dependency-free JS */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Mobile navigation drawer ---------- */
  function initNav() {
    var drawer = $('#NavDrawer');
    if (!drawer) return;
    var toggles = $$('[data-nav-toggle]');
    var lastFocus = null;

    function setOpen(open) {
      drawer.hidden = !open;
      document.body.classList.toggle('nav-open', open);
      toggles.forEach(function (t) { if (t.getAttribute('aria-controls')) t.setAttribute('aria-expanded', String(open)); });
      if (open) {
        lastFocus = document.activeElement;
        var first = $('a, button', drawer);
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () { setOpen(drawer.hidden); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) setOpen(false);
    });
  }

  /* ---------- Search panel ---------- */
  function initSearch() {
    var btn = $('[data-search-toggle]');
    var panel = $('#SearchPanel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) { var i = $('input[type="search"]', panel); if (i) i.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });
  }

  /* ---------- Toast + cart count ---------- */
  var toastTimer;
  function toast(html, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.dataset.error = isError ? 'true' : 'false';
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.empty = count === 0 ? 'true' : 'false';
    });
  }

  /* ---------- Ajax add to cart ---------- */
  function initAjaxForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ajax-form]');
      if (!form) return;
      e.preventDefault();

      var btn = $('[type="submit"]', form);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || window.theme.strings.error);
          return fetch(window.theme.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          toast(window.theme.strings.added + ' <a href="' + window.theme.routes.cart + '">' + window.theme.strings.viewCart + '</a>', false);
        })
        .catch(function (err) {
          toast(err.message || window.theme.strings.error, true);
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = $('input', wrap);
      var step = parseInt(btn.dataset.qtyStep, 10);
      var min = parseInt(input.min || '0', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Cart page: submit the form after quantity changes
    var cartForm = $('[data-cart-form]');
    if (cartForm) {
      var t;
      cartForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-cart-qty]')) return;
        clearTimeout(t);
        t = setTimeout(function () { cartForm.requestSubmit(); }, 400);
      });
    }
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var toggle = $('[data-filter-toggle]');
    var panel = $('#FilterPanel');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      });
    }
    var form = $('[data-filter-form]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-sort]')) {
        // keep sort in sync inside the filter form
        form.requestSubmit();
        return;
      }
      if (e.target.matches('input[type="checkbox"]')) form.requestSubmit();
    });
    form.addEventListener('submit', function () {
      // Don't send empty fields so URLs stay tidy
      $$('input', form).forEach(function (i) { if (i.type !== 'checkbox' && i.value === '') i.disabled = true; });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('[data-product]').forEach(function (root) {
      var variantsEl = $('[data-variants]', root);
      if (!variantsEl) return;
      var variants = JSON.parse(variantsEl.textContent);
      var form = $('[data-product-form]', root);
      var idInput = $('input[name="id"]', form);
      var track = $('[data-gallery-track]', root);
      var thumbs = $$('[data-thumb]', root);
      var sticky = $('[data-sticky-buy]', root);
      var isMain = root.dataset.updateUrl === 'true';

      function selectedOptions() {
        var groups = $$('[data-option-group]', root);
        return groups.map(function (g) {
          var checked = $('input:checked', g);
          return checked ? checked.value : null;
        });
      }

      function setMedia(id) {
        if (!track || !id) return;
        var el = $('[data-media-id="' + id + '"]', track);
        if (el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function render(variant) {
        var priceHtml;
        if (!variant) {
          $$('[data-add-btn]', root).forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
          return;
        }
        idInput.value = variant.id;
        if (variant.on_sale) {
          priceHtml = '<span class="price__current">' + variant.price + '</span> <s class="price__compare">' + variant.compare + '</s>';
        } else {
          priceHtml = '<span class="price__current">' + variant.price + '</span>';
        }
        $$('[data-price]', root).forEach(function (p) {
          p.innerHTML = priceHtml;
          p.classList.toggle('price--sale', variant.on_sale);
        });
        $$('[data-add-btn]', root).forEach(function (b) {
          b.disabled = !variant.available;
          b.textContent = variant.available ? 'Add to cart' : 'Sold out';
        });
        $$('[data-option-label]', root).forEach(function (l) {
          var idx = parseInt(l.dataset.optionLabel, 10);
          l.textContent = variant.options[idx];
        });
        setMedia(variant.media);
        if (isMain && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-option-group]')) return;
        var sel = selectedOptions();
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        })[0];
        render(match);
      });

      // Mark unavailable combos (single-option or simple cases)
      thumbs.forEach(function (th) {
        th.addEventListener('click', function () { setMedia(th.dataset.thumb); });
      });
      if (track && thumbs.length) {
        var items = $$('[data-media-id]', track);
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          var current = items[idx];
          thumbs.forEach(function (th) {
            th.setAttribute('aria-current', String(current && th.dataset.thumb === current.dataset.mediaId));
          });
        }, { passive: true });
      }

      // Sticky mobile buy bar appears once the main button is out of view
      var mainBtn = $('[data-main-buy]', root);
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(mainBtn);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initSearch();
    initAjaxForms();
    initQty();
    initFilters();
    initProduct();
  });
})();
